export default "__VITE_ASSET__Be86eCi9__"